export enum SurveyTypeEnum {
    NPS = 'NPS',
    CSAT = 'CSAT',
}